import React, { useContext, useEffect, useState } from 'react'
import { CCard, CButton, CFormCheck } from '@coreui/react'
import '../content.scss'
import '../../../../scss/style.scss'
import { getThumbnail, isEmpty, raiseToast } from '../../../utils/helper'
import moment from 'moment'
import useAxios from 'axios-hooks'
import { AppContext } from 'src/views/context/app'
import {
  SUBSCRIPTION_API,
  VENUE_LIST_API,
  ARTIST_LIST_API,
  META_DATA_URL,
  PLAYLIST_METADATA,
} from '../../../utils/urls'
import { GlobalContext } from 'src/views/context/GlobalState'
import PreviewDetails from '../../AssetManager/PreviewDetails'
import { capitalize } from 'lodash'
import ManualPlaylist from './manualPlaylist'
import AutoGeneratedPlaylist from './autoGeneratedPlaylist'
import DefaultDynamicPreview from 'src/components/template/default/defaultDynamicPreview'
import DefaultSwimlanePreview from 'src/components/template/default/defaultSwimlanePreview'
import { useDispatch } from 'react-redux'

const Playlist = (props) => {
  const { toggleValue, isEdit, details, cancelModal } = props
  const { userSessionObj } = useContext(GlobalContext)
  const [autoGenrate, setAutoGenrate] = useState(false)
  const [previewContent, setPreviewContent] = useState({})
  // const [swimlanePreviewContents, setSwimlanePreviewContents] = useState([])
  const [basicInfo, setBasicInfo] = useState([])

  const [selectedContents, setSelectedContents] = useState([])

  const [playlistPreview, setPlaylistPreview] = useState(false)
  const [autoPayload, setAutoPayload] = useState([])
  const { setLoader } = useContext(AppContext)
  const dispatch = useDispatch()

  const [{ data: categories, loading: categoriesLoading }] = useAxios({
    url: `${META_DATA_URL}/system`,
    method: 'get',
  })

  const [{ data: subscriptionList, loading: subscriptionListLoading }] = useAxios({
    url: SUBSCRIPTION_API + '?type=normal',
    method: 'get',
  })

  const [{ data: ppvList, loading: ppvListLoading }] = useAxios({
    url: SUBSCRIPTION_API + '?type=ppv',
    method: 'get',
  })

  const [{ data: artist, loading: artistLoading }] = useAxios({
    url: ARTIST_LIST_API,
    method: 'get',
  })

  const [{ data: venue, loading: venueLoading }] = useAxios({
    url: VENUE_LIST_API,
    method: 'get',
  })

  const [{ data: customMetadata, loading: customMetadataLoading }] = useAxios({
    url: `${META_DATA_URL}/custom/content`,
    method: 'get',
  })

  const [{ loading: playlistMetadataLoading }, playlistMetadataCall] = useAxios(
    {
      url: PLAYLIST_METADATA,
      method: 'post',
    },
    { manual: true },
  )

  useEffect(() => {
    if (isEdit && !isEmpty(details) && details?.video_type === 'PLAYLIST') {
      setAutoGenrate(details?.playlist_data?.playlist_type === 'AUTO')
      if (details?.playlist_data?.playlist_type === 'MANUAL') {
        setSelectedContents(
          details?.playlist_data?.content_data ? details?.playlist_data?.content_data : [],
        )
        setPlaylistPreview(true)
      }
      if (details?.playlist_data?.playlist_type === 'AUTO') {
        setAutoPayload(
          details?.playlist_data?.auto_payload ? details?.playlist_data?.auto_payload : [],
        )
      }
    }
  }, [isEdit, details])

  useEffect(() => {
    setLoader(
      customMetadataLoading ||
        categoriesLoading ||
        artistLoading ||
        venueLoading ||
        subscriptionListLoading ||
        ppvListLoading ||
        playlistMetadataLoading,
    )
  }, [
    customMetadataLoading,
    categoriesLoading,
    artistLoading,
    venueLoading,
    subscriptionListLoading,
    ppvListLoading,
    playlistMetadataLoading,
  ])

  useEffect(() => {
    setBasicInfo([
      {
        property: 'Title',
        value: previewContent.title,
      },
      {
        property: 'Description',
        value: previewContent?.description,
      },
      {
        property: 'Content Type',
        value: previewContent?.video_type,
      },
      {
        property: 'File Type',
        value: previewContent?.asset_type,
      },

      {
        property: 'Category',
        value: !isEmpty(previewContent?.category)
          ? [...previewContent?.category].map((info) => info.name).toString()
          : '',
      },
      { property: 'Status', value: capitalize(String(previewContent?.publish_policy)) },
      {
        property: 'Monetization',
        value:
          previewContent?.active_subscription?.length > 0 ||
          previewContent?.active_ppv_subscription?.length > 0
            ? 'Paid'
            : 'Free',
      },
      {
        property: 'Publish Time',
        value: moment(previewContent?.publish_time).format('DD MMM YYYY'),
      },
      { property: 'Permalink', value: 'N/A' },
    ])
  }, [previewContent])

  const validateInfo = () => {
    let isFormValid = true

    if (!autoGenrate && isEmpty(selectedContents)) {
      isFormValid = false
      raiseToast('error', 'Select a Content!')
    }

    return isFormValid
  }

  const handleSaveNext = async () => {
    if (!validateInfo()) return

    let playlistMetaRes = await playlistMetadataCall({
      data: {
        playlist_type: autoGenrate ? 'AUTO' : 'MANUAL',
        data: autoGenrate
          ? {
              system_defined: autoPayload.filter((info) => info.type === 'system_defined'),
              custom_defined: autoPayload.filter((info) => info.type === 'custom_defined'),
            }
          : selectedContents,
      },
    })

    let playlisMetadata = playlistMetaRes.data

    if (playlisMetadata.success) {
      dispatch({
        type: 'PLAYLIST',
        payload: {
          playlistData: {
            playlist_type: autoGenrate ? 'AUTO' : 'MANUAL',
            auto_payload: autoGenrate ? autoPayload : [],
            content_data: autoGenrate ? [] : selectedContents,
          },
          category: playlisMetadata?.data?.categories,
          subCategories: playlisMetadata?.data?.sub_categories,
          artists: playlisMetadata?.data?.artists,
          venues: playlisMetadata?.data?.venues,
        },
      })

      toggleValue(3)
      return
    }
    raiseToast('error', 'Error Fetching Metadata.')
  }

  const handlePreview = () => {
    if (!autoGenrate && isEmpty(selectedContents)) {
      raiseToast('error', 'Select a Content!')
      return
    }
    setPlaylistPreview(true)
  }

  return (
    <>
      <CCard>
        {!isEmpty(previewContent) && (
          <PreviewDetails
            onClose={() => setPreviewContent({})}
            cardImage={getThumbnail(
              userSessionObj.session_data.cf_domain_name,
              previewContent?.thumbnail,
            )}
            headline="Content Preview"
            subHeadline="Detailed information about the selected Content"
            basicInfo={basicInfo}
            resolutions={{}}
          />
        )}
        <div style={{ marginTop: '1.5vw', padding: '0 5vw' }}>
          {playlistPreview ? (
            autoGenrate ? (
              <DefaultDynamicPreview
                filterData={{
                  system_defined: autoPayload.filter((info) => info.type === 'system_defined'),
                  custom_defined: autoPayload.filter((info) => info.type === 'custom_defined'),
                  video_types: ['SPV', 'MPVC'],
                }}
                title="Playlist"
              />
            ) : (
              <DefaultSwimlanePreview
                title="Playlist"
                filterData={{ content_ids: selectedContents }}
                setContentData={(arr) => {
                  setSelectedContents(arr.map((ele) => ele.content_id))
                }}
                goBackToSelection={() => setPlaylistPreview(false)}
              />
            )
          ) : (
            <>
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <h5
                    style={{
                      color: '#191818',
                      fontSize: '30px',
                      fontWeight: '700',
                      marginBlockEnd: '0',
                    }}
                  >
                    {autoGenrate ? 'FILTER CONTENTS' : 'Select Contents'}
                  </h5>
                  <span style={{ fontSize: '.95vw', fontWeight: '600' }}>
                    {autoGenrate
                      ? 'Define a filtering criteria to create a Dynamic Playlist from Content Library'
                      : 'Select a list of Contents to create a Static Playlist from Content Library'}
                  </span>
                </div>
                <div
                  className="d-flex justify-content-center align-items-center rounded-1 overflow-hidden"
                  style={{ border: '0.5px solid #707070' }}
                >
                  <CFormCheck
                    className="playlist-generation-cformcheck"
                    type="radio"
                    id="flexRadioDefault1"
                    label="Manually Generate"
                    value="manual"
                    checked={!autoGenrate}
                    onChange={() => setAutoGenrate(!autoGenrate)}
                    disabled={false}
                  />
                  <CFormCheck
                    className="playlist-generation-cformcheck"
                    type="radio"
                    id="flexRadioDefault2"
                    label="Auto Generate"
                    value="auto"
                    checked={autoGenrate}
                    onChange={() => setAutoGenrate(!autoGenrate)}
                    disabled={false}
                  />
                </div>
              </div>
              {autoGenrate ? (
                <AutoGeneratedPlaylist
                  payload={autoPayload}
                  setPayload={setAutoPayload}
                  customMetadataMaster={customMetadata?.data?.filter(
                    (info) => info.status && info.type !== 'text',
                  )}
                  categoryMasterData={categories?.data?.filter(
                    (info) => info.status && info.type === 'category',
                  )}
                  subCategoryMasterData={categories?.data?.filter(
                    (info) => info.status && info.type === 'sub_category',
                  )}
                  subscriptionMasterData={subscriptionList?.data?.filter((info) => info.status)}
                  ppvMasterData={ppvList?.data?.filter((info) => info.status)}
                  artistData={artist?.data?.filter((info) => info.status)}
                />
              ) : (
                // asset manager lookalike content manager(content listing) */
                <ManualPlaylist
                  selectedContents={selectedContents}
                  setSelectedContents={setSelectedContents}
                  setPreviewContent={setPreviewContent}
                  setSwimlanePreviewContents={(arr) => {}}
                  categoryMasterData={categories?.data?.filter(
                    (info) => info.status && info.type === 'category',
                  )}
                  subCategoryMasterData={categories?.data?.filter(
                    (info) => info.status && info.type === 'sub_category',
                  )}
                  subscriptionMasterData={subscriptionList?.data?.filter((info) => info.status)}
                  ppvMasterData={ppvList?.data?.filter((info) => info.status)}
                  artistData={artist?.data?.filter((info) => info.status)}
                />
              )}
            </>
          )}

          {/* // auto generation(filter contents) div */}

          <div className="mt-3 w-100">
            <div className=" d-flex justify-content-end pb-3">
              <CButton
                style={{ color: 'black', border: '1px solid #bdbdbd' }}
                className="mx-4 bg-white rounded-1 btn-focus-none"
                onClick={() => cancelModal(true)}
              >
                Cancel
              </CButton>
              <CButton
                style={{ backgroundColor: '#20211c' }}
                className="px-3 rounded-1 btn-focus-none"
                onClick={() => {
                  playlistPreview ? handleSaveNext() : handlePreview()
                }}
              >
                {playlistPreview ? 'Save & Next' : 'Preview'}
              </CButton>
            </div>
          </div>
        </div>
      </CCard>
    </>
  )
}

export default Playlist
